import * as React from 'react';
import { formField, IformField } from 'framework/components/hoc/formField';
import { CheckboxPrimitive, CheckboxPrimitiveTypes } from '../Primitives/CheckboxPrimitive';

const Checkbox = (props: CheckboxPrimitiveTypes) => <CheckboxPrimitive {...props} />;

export default (formField(Checkbox) as any) as React.StatelessComponent<CheckboxPrimitiveTypes & IformField>;
